import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ListProductHostingComponent from "../../../components/Customer/products/ListProductHostingComponent";

const CreateProductPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return <ListProductHostingComponent groupProductId={ params.groupProductId } shouldRedirect={ () => redirect() } />;
}

export default CreateProductPage;